import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

/**
 * Rollback behaviour for the invoice sub-pages that were born in the Svelte
 * bundle and have **no Angular twin**:
 *
 * - `/invoices/:invoiceId/activity` (add-invoice-activity-page, design D5);
 * - `/invoices/:invoiceId/documents` (preview-invoices-with-transfer-statements).
 *
 * Their Angular routes exist only so each URL is declared and guarded like
 * every other migrated URL, but there is nothing here to render. When the
 * BFF's `location` block for a sub-path is removed (per-page rollback is a
 * routing-config-only change), Angular receives the URL and this guard
 * redirects to the nearest Angular-owned parent, `/invoices/:invoiceId`,
 * instead of leaving the user on a blank or not-found page. Rollback therefore
 * means "the feature is unavailable", not "an older Angular version returns".
 *
 * `StranglerGuard` runs before this one and owns the non-rolled-back case:
 * an in-app navigation becomes a document load the BFF can route.
 *
 * One guard serves every such sub-page, so a new one is a route entry, not a
 * new guard.
 */
@Injectable()
export class InvoiceSubPageRollbackGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): UrlTree {
    return this.router.parseUrl('/invoices/' + route.paramMap.get('invoiceId'));
  }
}
